import { Component, inject } from '@angular/core';
import { ParameterService } from '@frontend/frontendlib';

@Component({
  selector: 'app-choosepayment-coupon-cashing',
  templateUrl: './choosepayment-coupon-cashing.component.html',
  styleUrls: ['./choosepayment-coupon-cashing.component.css'],
  standalone: false,
})
export class ChoosepaymentCouponCashingComponent {
  public parameterService = inject(ParameterService);
}
